import { render } from "./HeaderNav.vue?vue&type=template&id=5e622ab9&scoped=true&bindings={}"
import script from "./HeaderNav.vue?vue&type=script&lang=ts"
export * from "./HeaderNav.vue?vue&type=script&lang=ts"

import "./HeaderNav.vue?vue&type=style&index=0&id=5e622ab9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e622ab9"

export default script